import React, { useContext, useEffect, useState } from 'react'
import { Box } from '@mui/material'

import LanguageContext from '../../../contexts/LanguageContext'
import { useTexte } from '../../../contexts/FormeAdresseContext'
import { fabriquerImagePartage } from './imageBilan'
import EditableButton from '../Formats/EditableButton'
import vignetteModule from '../../../images/vignetteModule.png'

/* ⛔ VIGNETTE DE FIN DE PROGRAMME (08/10/2026, maquette v3, cas A, validee par
   Nawal). Quand le programme est termine (icebreaker et tous les modules, la
   regle qui deverrouille le bilan) et qu'il n'est PAS certifiant, la carte du
   module en cours ne montre plus le dernier ecran du dernier module : elle
   montre un APERCU DU VRAI BILAN de l'apprenant, l'image de partage LinkedIn
   (onglet LinkedIn de la fenetre du bilan), fabriquee dans le navigateur
   comme aujourd'hui (fabriquerImagePartage), reduite et legerement inclinee
   sur le fond de la bande de reponse. Le bouton noir ouvre la fenetre du
   bilan.
   Bilan incomplet (moins de 3 competences) : pas d'apercu ni de bouton, la
   mosaique des modules et un renvoi vers « Ton programme ».
   Le cas certifiant (direction « Ma certification ») viendra apres.
   Les emplacements du titre (une ligne) et du texte (deux lignes) restent ceux
   de la carte (Dashboard.js, 06/10/2026) : les textes sont ecrits pour y tenir. */

export const FOND_VISUEL = '#FAF8F6'

/* l'apercu : un object URL de l'image, rien tant qu'elle n'est pas prete ou si
   le navigateur ne sait pas la fabriquer (aucune erreur montree) */
export const useApercuBilan = (donnees, actif) => {
  const [url, setUrl] = useState(null)
  useEffect(() => {
    if (!actif || !donnees) { setUrl(null); return undefined }
    let vivant = true
    let cree = null
    /* `Promise.resolve().then` : une erreur levee tout de suite (navigateur
       sans canevas, module de test) finit dans le `catch`, comme les autres */
    Promise.resolve().then(() => fabriquerImagePartage(donnees))
      .then((blob) => {
        if (!vivant || !blob) return
        cree = URL.createObjectURL(blob)
        setUrl(cree)
      })
      .catch(() => { if (vivant) setUrl(null) })
    return () => { vivant = false; if (cree) URL.revokeObjectURL(cree) }
  }, [actif, donnees])
  return url
}

export const VisuelFinDeProgramme = ({ donnees, disponible, onOuvrir }) => {
  const url = useApercuBilan(donnees, disponible)
  return (
    <Box
      data-visuel-fin-programme
      onClick={disponible ? onOuvrir : undefined}
      sx={{
        width: '100%', height: '100%', position: 'relative', overflow: 'hidden',
        background: FOND_VISUEL, cursor: disponible ? 'pointer' : 'default',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      {disponible && url &&
        <Box component="img" src={url} alt="" data-apercu-bilan sx={{
          position: 'absolute', left: '50%', top: '22px',
          width: 'min(300px, 72%)',
          transform: 'translateX(-50%) rotate(-2.5deg)',
          boxShadow: '0 6px 24px rgba(0,0,0,0.14)',
          display: 'block',
        }} />
      }
      {disponible &&
        <Box aria-hidden sx={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: '70px', background: `linear-gradient(to bottom, rgba(250,248,246,0), ${FOND_VISUEL})` }} />
      }
      {!disponible &&
        <Box component="img" src={vignetteModule} alt="" sx={{ width: '96px', height: '96px', display: 'block' }} />
      }
    </Box>
  )
}

export const TitreFinDeProgramme = () => {
  const { languageValues } = useContext(LanguageContext)
  const t = useTexte()
  return t(languageValues?.dashboard?.finProgramme?.titre)
}

export const TexteFinDeProgramme = ({ disponible }) => {
  const { languageValues } = useContext(LanguageContext)
  const t = useTexte()
  return t(disponible ? languageValues?.dashboard?.finProgramme?.texteBilan : languageValues?.dashboard?.finProgramme?.texteSansBilan)
}

export const BoutonVoirBilan = ({ onClick }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  return (
    <EditableButton
      isEditor={false}
      field={languageValues?.dashboard?.finProgramme?.bouton?.[actLanguage]}
      onClick={onClick}
      data-voir-bilan-carte
    />
  )
}
